import { takeLatest, takeEvery } from 'redux-saga/effects';
import { DISPLAY_SETTINGS_UPDATE_START_CHANNELS, DISPLAY_SETTINGS_FETCH_SUCCESS } from 'common/actions/settings';
import { updateStartChannelsEffect } from 'common/sagas/effects/update-start-channels';
import { loadYammerSDKEffect } from 'common/sagas/effects/load-yammer';
import { loadFacebookSDKEffect } from 'common/sagas/effects/load-facebook-sdk';

export const settingsSaga = function* () {
  yield takeEvery(DISPLAY_SETTINGS_UPDATE_START_CHANNELS, updateStartChannelsEffect);
  yield takeLatest(DISPLAY_SETTINGS_FETCH_SUCCESS, loadYammerSDKEffect);
  yield takeLatest(DISPLAY_SETTINGS_FETCH_SUCCESS, loadFacebookSDKEffect);
};
